import React, { useState } from 'react'
import { svgIcons } from '../../../style/fonts/SvgIcons'
import { Link } from 'react-router-dom'
import Table from "../../../core/common/dataTable/index";
import { TableData } from "../../../core/data/interface";
import { businessUnitData } from './BusinessUnitData';
import { useGetAllBusinessUnitsQuery } from '../../../services/EndPointsApis';
import { Key } from 'react-feather';
import TextField from '../../../core/common/textFields/TextField';
import NoRecordFound from '../../../core/common/noRecord/NoRecordFound';
import TableLoading from '../../../core/common/loadingComponent/TableLoading';
import { useTableSelection } from '../../../core/hooks/useTableSelection';
import Ribbon, { ToggleButton } from '../../../core/common/ribbon/ribbon';
import ActiveUserModal from './ActiveUserModal';


const BusinessUnit = () => {

  const [currentToggleState, setCurrentToggleState] = useState(false);
  const [showActiveUserModal, setShowActiveUserModal] = useState(false)

  
  const handleToggle = () => {
    const newToggleState = !currentToggleState;
    setCurrentToggleState(newToggleState);
    setShowActiveUserModal(true);
  }
  const handleCloseStatusModal = () => {
    setShowActiveUserModal(false);
  };
  const { data: allBusinessUnits, refetch,isLoading } = useGetAllBusinessUnitsQuery(''); //get alluser api

const {
  isTableHeadChecked,
  selectedIndividualCheckboxId,
  selectedItemData: BusinessUnitData,
  handleTableHeadChange,
  handleCheckItem,
  handleRowClick,
} = useTableSelection(allBusinessUnits?.result || [], 'id');

const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;

    const items=[
      {
        label: "Active",
        onClick: () => {
          setShowActiveUserModal(true);
        },
        ToggleButton: <ToggleButton
          onChange={handleToggle}
          id="toggle"
          checked={currentToggleState}
          disableButton={!isAnyCheckboxChecked || isMoreThanOneChecked}
           />
      },
    ]
    return (
      <>
       {/* <ActiveUserModal
        show={showActiveUserModal}
        handleClose={handleCloseStatusModal}
        data={BusinessUnitData}
      /> */}
        <div className="page-wrapper">
            <div className="content">
                <div className='row'>
                    <div className='col-md-12'>
                       <h4 className='mb-2'>
                        Business Units
                       </h4>
                       {/* <Ribbon
                       items={items}
                       /> */}
                    </div>
                    <div>
                    <div className="table-responsive custom-table">
                <table className="table datanew dataTable no-footer table-hover">
                  <thead>
                    <tr>
                    {/* <th>
                          <input
                            type="checkbox"
                            className='form-check-input cursor-pointer'
                            checked={isTableHeadChecked}
                            onChange={handleTableHeadChange}
                          />
                        </th> */}
                      <th>ID</th>
                      <th>NAME</th>
                      <th>STATUS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isLoading &&
                      <>
                        {allBusinessUnits?.result?.length > 0 ? (
                          <>
                            {allBusinessUnits?.result?.map((data: any, index: any) => {
                              return (
                                <tr key={data.id} onClick={() => handleRowClick(data)}
                                  className={selectedIndividualCheckboxId.includes(data.id) ? 'selected-row' : ''}>
                                     {/* <td>
                                  <TextField
                                    type="checkbox"
                                    fieldClass='form-check-input cursor-pointer'
                                    checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.id)}
                                    onChange={(e:any) => handleCheckItem(e, data)}
                                  />
                                </td> */}
                                  <td>{data?.id}</td>
                                  <td>{data?.buName}</td>
                                  <td>
                                    {data?.isActive === true ? (
                                      <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                    ) : (
                                      <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                    )}
                                  </td>
                                </tr>
                              )
                      })}
                          </>
                        ) :
                          (<tr>
                            <td colSpan={7}>
                              <NoRecordFound />
                            </td>
                          </tr> )}
                      </>
                          }
                    {isLoading &&
                      <TableLoading />
                    }
                  </tbody>
                </table>
              </div>
                   
                    </div>
                </div>
            </div>
        </div>
      </>

    )
}

export default BusinessUnit